import React from 'react';
import List from './List';
import graph from './graph';
import NewBaseModel from 'components/NewBaseModel';

export default function Model(props) {
  return (
    <NewBaseModel graph={graph} {...props}>
      <List />
    </NewBaseModel>
  );
}
